import * as sterlingparker from './MatchesV2.styles.sterlingparker';
import * as puntgenie from './MatchesV2.styles.puntgenie';
import * as volcanobet from './MatchesV2.styles.volcanobet';
import * as betprofessor from './MatchesV2.styles.betprofessor';
import * as fiestabet from './MatchesV2.styles.fiestabet';
import * as puntcity from './MatchesV2.styles.puntcity';
import * as betgalaxy from './MatchesV2.styles.betgalaxy';
import * as betroyale from './MatchesV2.styles.betroyale';
import * as juicybet from './MatchesV2.styles.juicybet';
import * as goldenrush from './MatchesV2.styles.goldenrush';
import * as questbet from './MatchesV2.styles.questbet';
import * as wellbet from './MatchesV2.styles.wellbet';
import * as sugarcastle from './MatchesV2.styles.sugarcastle';
import * as oldgill from './MatchesV2.styles.oldgill';
import * as buffalobet from './MatchesV2.styles.buffalobet';
import * as titanbet from './MatchesV2.styles.titanbet';
import * as gigabet from './MatchesV2.styles.gigabet';
import * as slambet from './MatchesV2.styles.slambet';
import * as betstride from './MatchesV2.styles.betstride';
import * as templebet from './MatchesV2.styles.templebet';
import * as goldenbet888 from './MatchesV2.styles.goldenbet888';
import * as hyperbet from './MatchesV2.styles.hyperbet';
import * as bet777 from './MatchesV2.styles.bet777';
import * as chromabet from './MatchesV2.styles.chromabet';
import * as bet575 from './MatchesV2.styles.bet575';
import * as betblast from './MatchesV2.styles.betblast';
import * as pyramidbet from './MatchesV2.styles.pyramidbet';
import * as magnumbet from './MatchesV2.styles.magnumbet';
import * as vikingbet from './MatchesV2.styles.vikingbet';

import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sterlingparker,
  puntgenie,
  volcanobet,
  betprofessor,
  fiestabet,
  puntcity,
  betgalaxy,
  betroyale,
  juicybet,
  goldenrush,
  questbet,
  wellbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
  vikingbet,
};
